import styled from 'styled-components';


export const LicenseItemWrapper = styled.div`
  width: calc(100% - 10px);
  height: 100px;
  margin: 5px;
  background-color: #ffffff10;
  border-radius: 10px;

  display: flex;
  flex-flow: row;
  
  
  :hover {
    background-color: #ffffff15;
  }

  > div {
    flex: 1;
    height: calc(100% - 10px);
    max-height: calc(100% - 10px);
    display: grid;
    grid-template-columns: auto;
    cursor: pointer;
    padding: 5px;
    position: relative;
    align-items: center;

    > div {
      display: flex;
      flex-flow: row;
    }

    span {
      font-size: 18px;
      margin: 0px;
      padding: 0px;
      pointer-events: none;
      max-width: calc(100% - 20px);
    }

    .Linked {
      width: auto;
      pointer-events: all;
      cursor: pointer;
      > u {
        font-size: 18px;
        color: #156EAC;
      }
    }

    .IconRight {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
`;

export default LicenseItemWrapper;